import { ChapterOptions } from '../types';
import { LinkWChart, LinkWChartTopic } from '../types/link';

export const STATE_OPTIONS = [
	{ label: 'Alabama', id: 'al' },
	{ label: 'Alaska', id: 'ak' },
	{ label: 'Arizona', id: 'az' },
	{ label: 'Arkansas', id: 'ar' },
	{ label: 'California', id: 'ca' },
	{ label: 'Colorado', id: 'co' },
	{ label: 'Connecticut', id: 'ct' },
	{ label: 'Delaware', id: 'de' },
	{ label: 'Florida', id: 'fl' },
	{ label: 'Georgia', id: 'ga' },
	{ label: 'Hawaii', id: 'hi' },
	{ label: 'Idaho', id: 'id' },
	{ label: 'Illinois', id: 'il' },
	{ label: 'Indiana', id: 'in' },
	{ label: 'Iowa', id: 'ia' },
	{ label: 'Kansas', id: 'ks' },
	{ label: 'Kentucky', id: 'ky' },
	{ label: 'Louisiana', id: 'la' },
	{ label: 'Maine', id: 'me' },
	{ label: 'Maryland', id: 'md' },
	{ label: 'Massachusetts', id: 'ma' },
	{ label: 'Michigan', id: 'mi' },
	{ label: 'Minnesota', id: 'mn' },
	{ label: 'Mississippi', id: 'ms' },
	{ label: 'Missouri', id: 'mo' },
	{ label: 'Montana', id: 'mt' },
	{ label: 'Nebraska', id: 'ne' },
	{ label: 'Nevada', id: 'nv' },
	{ label: 'New Hampshire', id: 'nh' },
	{ label: 'New Jersey', id: 'nj' },
	{ label: 'New Mexico', id: 'nm' },
	{ label: 'New York', id: 'ny' },
	{ label: 'North Carolina', id: 'nc' },
	{ label: 'North Dakota', id: 'nd' },
	{ label: 'Ohio', id: 'oh' },
	{ label: 'Oklahoma', id: 'ok' },
	{ label: 'Oregon', id: 'or' },
	{ label: 'Pennsylvania', id: 'pa' },
	{ label: 'Rhode Island', id: 'ri' },
	{ label: 'South Carolina', id: 'sc' },
	{ label: 'South Dakota', id: 'sd' },
	{ label: 'Tennessee', id: 'tn' },
	{ label: 'Texas', id: 'tx' },
	{ label: 'Utah', id: 'ut' },
	{ label: 'Vermont', id: 'vt' },
	{ label: 'Virginia', id: 'va' },
	{ label: 'Washington', id: 'wa' },
	{ label: 'West Virginia', id: 'wv' },
	{ label: 'Wisconsin', id: 'wi' },
	{ label: 'Wyoming', id: 'wy' }
];

export const TEN_STATE_OPTIONS = [
	{ label: 'Arizona', id: 'az' },
	{ label: 'Colorado', id: 'co' },
	{ label: 'Florida', id: 'fl' },
	{ label: 'Georgia', id: 'ga' },
	{ label: 'Massachusetts', id: 'ma' },
	{ label: 'Michigan', id: 'mi' },
	{ label: 'New Mexico', id: 'nm' },
	{ label: 'Ohio', id: 'oh' },
	{ label: 'Pennsylvania', id: 'pa' },
	{ label: 'Washington', id: 'wa' }
];

export const TEN_STATE_STATE_OPTIONS = [
	{ label: 'Arizona', id: 'az' },
	{ label: 'Colorado', id: 'co' },
	{ label: 'Florida', id: 'fl' },
	{ label: 'Georgia', id: 'ga' },
	{ label: 'Massachusetts', id: 'ma' },
	{ label: 'Michigan', id: 'mi' },
	{ label: 'New Mexico', id: 'nm' },
	{ label: 'Ohio', id: 'oh' },
	{ label: 'Pennsylvania', id: 'pa' },
	{ label: 'Washington', id: 'wa' }
];

export const ELECTION_OPTIONS = [
	{ label: 'State Elections', id: 'state' },
	{ label: 'Congressional Elections', id: 'congress' }
];

export const SEAT_OPTIONS = [
	{ label: 'Open Seat', id: 'open' },
	{ label: 'Challenger', id: 'challenger' },
	{ label: 'Incumbent', id: 'incumbent' }
];

export const FILTER_BOX = [
	{ label: "Filter data by women's race/ethnicity", id: 'true' }
];
export const DONOR_FILTER_BOX = [
	{ label: "Filter data by women candidates' race/ethnicity", id: 'true' }
];
export const CONGRESSIONAL_TABS = [
	{ label: 'US Senate', id: 'senate' },
	{ label: 'US House', id: 'house' }
];

export const DONOR_TABS = [
	{ label: '% of money', id: 'moeny' },
	{ label: '% of contributors', id: 'contributors' }
];

export const DATA_BASE_URL =
	'https://graphicacy-ru-cawp-next.pantheonsite.io/sites/default/files/data/';

export const SCRAMBLE_APPENDIX_ENABLED = false;

export const BASE_URL = '/research/cawp-women-money-and-politics-series/';

export const STATES_WITH_EDGE_CASES = ['wa', 'az', 'pa']; //taking out 'ga' for now

// Function to get landing URL for a specific year
export const getLandingUrl = (year: number): string => year === 2024 ? `money-watch-${year}` : `${year}/wmpw-${year}-landing-page`;

// Legacy constant for backwards compatibility (uses 2024)
export const LANDINGURL = getLandingUrl(2024);

export const DONOR_FLAGS = {
	nationalDisabled: false,
	nationalDisabledText: 'Coming in September 2024'
};

// Function to get chapters for a specific year
export const getChapters = (year: number) => {
	const landingUrl = getLandingUrl(year);

	return {
		analysis: {
			url: year === 2024 ? `${landingUrl}/final-analysis` : `${year}/wmpw-${year}-final-analysis`,
			header: 'Final Analysis',
			subheader: 'Congressional & State Elections',
			disabled: false,
			disabledText: '',
			chapter: 'analysis' as ChapterOptions,
			links: [
				{ href: 'congressional', label: 'Congressional Elections' },
				{ href: 'state', label: 'State Elections' }
			]
		},
		state: {
			url: year === 2024 ? `${landingUrl}/state` : `${year}/wmpw-${year}-state-view`,
			header: 'The State View',
			subheader: 'A Deep Dive into 10 States',
			disabled: false,
			disabledText: '',
			chapter: 'candidates' as ChapterOptions,
			links: [
				{ href: 'highlights', label: 'Highlights' },
				{
					href: 'totalRaised',
					label: 'Total Raised',
					dynamic: true,
					keyStatIndex: 0,
					chart: 'TotalRaised'
				},
				{
					href: 'selfFinanced',
					label: '% Self Financed',
					dynamic: true,
					keyStatIndex: 1,
					chart: 'SelfFinanced'
				},
				{
					href: 'smallContributions',
					label: '% Small Contributions',
					dynamic: true,
					keyStatIndex: 2,
					chart: 'SmallContributions'
				},
				{ href: 'dataAppendix', label: 'Data Appendix' },
				{ href: 'methodology', label: 'Methodology' }
			] as Array<LinkWChart>
		}, // State
		national: {
			url: year === 2024 ? `${landingUrl}/national` : `${year}/wmpw-${year}-national-view`,
			header: 'The National View',
			subheader: 'Congressional Elections',
			disabled: false,
			disabledText: '',
			chapter: 'opportunities' as ChapterOptions,
			links: [
				{ href: 'highlights', label: 'Highlights' },
				{
					href: 'totalRaised',
					label: 'Total Raised',
					dynamic: true,
					keyStatIndex: 0,
					chart: 'TotalRaised'
				},
				{
					href: 'selfFinanced',
					label: '% Self Financed',
					dynamic: true,
					keyStatIndex: 1,
					chart: 'SelfFinanced'
				},
				{
					href: 'smallContributions',
					label: '% Small Contributions',
					dynamic: true,
					keyStatIndex: 2,
					chart: 'SmallContributions'
				},
				{ href: 'dataAppendix', label: 'Data Appendix' },
				{ href: 'methodology', label: 'Methodology' }
			]
		}, // National
		donors: {
			url: year === 2024 ? `${landingUrl}/donor` : `${year}/wmpw-${year}-donor-gaps`,
			header: 'Donor Gaps',
			subheader: 'Demographics Analysis',
			disabled: false,
			disabledText: '',
			chapter: 'donors' as ChapterOptions,
			links: [
				{ href: 'highlights', label: 'Highlights' },
				{
					href: 'donorGender',
					label: 'Donor Gender',
					dynamic: true,
					keyStatIndex: 0,
					chart: 'DonorGender',
					topic: 'gender'
				},
				{
					href: 'donorRace',
					label: 'Donor Race/Ethnicity',
					dynamic: true,
					keyStatIndex: 1,
					chart: 'DonorRace',
					topic: 'race'
				},
				{
					href: 'donorEducation',
					label: 'Donor Education',
					dynamic: true,
					keyStatIndex: 2,
					chart: 'DonorEducation',
					topic: 'education'
				},
				{
					href: 'donorMaritalStatus',
					label: 'Donor Marital Status',
					dynamic: true,
					keyStatIndex: 3,
					chart: 'DonorMarital',
					topic: 'maritalStatus'
				},
				{
					href: 'donorAge',
					label: 'Donor Age',
					dynamic: true,
					keyStatIndex: 4,
					chart: 'DonorAge',
					topic: 'age'
				},
				{ href: 'methodology', label: 'Methodology' }
			] as Array<LinkWChartTopic>
		} // Donor
	};
};

// Legacy constant for backwards compatibility (uses 2024)
export const CHAPTERS = getChapters(2024);
